import { createSelector } from 'reselect';
import { getArsenalArmy } from '@Selectors/arsenal/selector/getArsenalArmy';
import { getAllEnumValues } from 'enum-for';
import { PaintStep } from '@Models';

export const shareArsenalArmySelector = createSelector(
  [getArsenalArmy],
  (army): string => {
    if (!army) return '';

    const units = army.units.flatMap((unit) => {
      const paintSteps = getAllEnumValues(PaintStep).map((step) => {
        const size = unit.steps.find((s) => s.step === step)?.size ?? 0;
        if (size === 0) return '';
        return ` • ${PaintStep[step]}: ${size}`;
      });

      return [`${unit.name}:`, ...paintSteps.filter((s) => s.length > 0), ''];
    });

    return (
      army.name +
      '\n' +
      '-'.repeat(20) +
      '\n' +
      '\n' +
      units.join('\n') +
      '\n' +
      '-'.repeat(20) +
      '\n' +
      'Retrouver mes miniatures sur le 9thbuilder :)\n\n' +
      '[https://www.9thbuilder.com/]'
    );
  },
);
